import { formatNumber } from '@/platform/lib/utils';
import {
    Input,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import { cell, sumOverYears } from '../calculations';

const YearGrid = ({ label, field, years, scan, onChange, children }) => {
    const { target_groups: targetGroups } = usePage().props;
    const ids = Object.keys(targetGroups || {});

    return (
        <Table striped>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell>{label}</TableHeaderCell>
                    {ids.map(id => (
                        <TableHeaderCell key={id} textAlign='right'>
                            {targetGroups[id]}
                        </TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {years.map(year => (
                    <TableRow key={year}>
                        <TableCell>{year}</TableCell>
                        {ids.map(id => (
                            <TableCell key={id} collapsing>
                                <Input
                                    type='number'
                                    aria-label={`${label} ${targetGroups[id]} ${year}`}
                                    value={cell(scan, id, year)[field]}
                                    onChange={event =>
                                        onChange(
                                            id,
                                            year,
                                            field,
                                            event.target.value
                                        )
                                    }
                                />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell>Totaal</TableCell>
                    {ids.map(id => (
                        <TableCell key={id} textAlign='right'>
                            {formatNumber(sumOverYears(scan, id, years, field))}
                        </TableCell>
                    ))}
                </TableRow>
                {children}
            </TableFooter>
        </Table>
    );
};

export default YearGrid;
